import {
  TOGGLE_EDIT_MODE,
  UPDATE_STUDENT_PERSONAL_DETAILS,
  UPDATE_STUDENT_TRANSCRIPT_COMMENT,
  RESET_ACADEMIC_RECORDS_MODULE,
  UPDATE_STUDENT_GRADE_RECORDS,
  DELETE_RECORD_ROW,
  ADD_NEW_COURSE_ROW,
  UPDATE_NEW_COURSE_ROW,
  DELETE_NEW_COURSE_ROW,
  UPDATE_NEW_COURSE_RATING,
  UPDATE_COURSE_LEVEL,
  UPDATE_COURSE_ID,
  CLEAR_DELETED_LEVEL_REFERENCES,
  CLEAR_DELETED_COURSE_REFERENCES,
} from "./AcademicRecordsModule";

export const toggleEditMode = () => ({
  type: TOGGLE_EDIT_MODE,
});

export const resetAcademicRecordsModule = () => ({
  type: RESET_ACADEMIC_RECORDS_MODULE,
});

export const updateStudentPersonalDetails = ({
  studentId,
  fieldUid,
  value,
}) => ({
  type: UPDATE_STUDENT_PERSONAL_DETAILS,
  payload: { studentId, fieldUid, value },
});

export const updateStudentTranscriptComment = ({ studentId, comment }) => ({
  type: UPDATE_STUDENT_TRANSCRIPT_COMMENT,
  payload: { studentId, comment },
});

export const deleteRecordRow = ({ studentId, gradeMapId, courseId }) => ({
  type: DELETE_RECORD_ROW,
  payload: { studentId, gradeMapId, courseId },
});

export const updateStudentGradeRecords = ({
  studentId,
  gradeMapId,
  courseId,
  gradingPeriodId,
  criteriaId,
  value,
}) => ({
  type: UPDATE_STUDENT_GRADE_RECORDS,
  payload: {
    studentId,
    gradeMapId,
    courseId,
    gradingPeriodId,
    criteriaId,
    value,
  },
});

export const addNewCourseRow = ({ studentId, gradeMapId, rowId }) => ({
  type: ADD_NEW_COURSE_ROW,
  payload: { studentId, gradeMapId, rowId },
});

export const updateNewCourseRow = ({
  studentId,
  gradeMapId,
  rowId,
  field,
  value,
}) => ({
  type: UPDATE_NEW_COURSE_ROW,
  payload: { studentId, gradeMapId, rowId, field, value },
});

export const deleteNewCourseRow = ({ studentId, gradeMapId, rowId }) => ({
  type: DELETE_NEW_COURSE_ROW,
  payload: { studentId, gradeMapId, rowId },
});

export const updateNewCourseRating = ({
  studentId,
  rowId,
  gradingPeriodId,
  criteriaId,
  value,
}) => ({
  type: UPDATE_NEW_COURSE_RATING,
  payload: { studentId, rowId, gradingPeriodId, criteriaId, value },
});

export const updateCourseLevel = ({
  studentId,
  gradeMapId,
  courseId,
  levelId,
}) => ({
  type: UPDATE_COURSE_LEVEL,
  payload: { studentId, gradeMapId, courseId, levelId },
});

export const updateCourseId = ({ studentId, gradeMapId, courseId, value }) => ({
  type: UPDATE_COURSE_ID,
  payload: { studentId, gradeMapId, courseId, value },
});

export const clearDeletedLevelReferences = ({ levelIds }) => ({
  type: CLEAR_DELETED_LEVEL_REFERENCES,
  payload: { levelIds },
});

export const clearDeletedCourseReferences = ({ courseIds }) => ({
  type: CLEAR_DELETED_COURSE_REFERENCES,
  payload: { courseIds },
});
